import React from 'react';
import { useNotionContext } from '../context';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
import { NotionBlockRenderer } from '../renderer';
export var SyncPointerBlock = function (props) {
    var _a, _b, _c, _d;
    var block = props.block, level = props.level;
    var recordMap = useNotionContext().recordMap;
    var retrieveMissingBlocks = UseRetrieveBlocks().retrieveMissingBlocks;
    if (!block) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn('missing block', block.id);
        }
        return null;
    }
    var syncPointerBlock = block;
    var referencePointerId = (_b = (_a = syncPointerBlock === null || syncPointerBlock === void 0 ? void 0 : syncPointerBlock.format) === null || _a === void 0 ? void 0 : _a.transclusion_reference_pointer) === null || _b === void 0 ? void 0 : _b.id;
    if (!referencePointerId)
        return null;
    // check for the block here and retrieve it and its children
    var syncBlock = recordMap.block[referencePointerId];
    var missingBlocks = [];
    if (!syncBlock) {
        missingBlocks.push({ id: referencePointerId, table: 'block' });
    }
    else {
        for (var _i = 0, _e = ((_c = syncBlock === null || syncBlock === void 0 ? void 0 : syncBlock.value) === null || _c === void 0 ? void 0 : _c.content) || []; _i < _e.length; _i++) {
            var blockId = _e[_i];
            var block_1 = (_d = recordMap.block[blockId]) === null || _d === void 0 ? void 0 : _d.value;
            if (block_1)
                continue;
            missingBlocks.push({ id: blockId, table: 'block' });
        }
    }
    missingBlocks.length > 0 && retrieveMissingBlocks(missingBlocks);
    return (React.createElement(NotionBlockRenderer, { key: referencePointerId, level: level, blockId: referencePointerId }));
};
//# sourceMappingURL=sync-pointer-block.js.map